import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-the-l01-news-list" }
const _hoisted_2 = { class: "p-the-l01-news-list__list" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  class: "p-the-l01-news-list__list__panel__title",
  "data-translate-skip": ""
}
const _hoisted_5 = { class: "p-the-l01-news-list__list__panel__info" }
const _hoisted_6 = { class: "p-the-l01-news-list__list__panel__info__item" }
const _hoisted_7 = { class: "p-the-l01-news-list__list__panel__info__item" }
const _hoisted_8 = { class: "p-the-l01-news-list__list__panel__info__item" }
const _hoisted_9 = { "data-translate-skip": "" }
const _hoisted_10 = {
  key: 0,
  class: "p-the-l01-news-list__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageNavi = _resolveComponent("PageNavi")!
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.whatsNewList, (news, key) => {
        return (_openBlock(), _createElementBlock("li", {
          key: key,
          class: "p-the-l01-news-list__list__panel"
        }, [
          _withDirectives((_openBlock(), _createElementBlock("a", {
            href: _ctx.urlWhatsNewDetail + '?id=' + news.pk,
            class: "p-the-l01-news-list__list__panel__link"
          }, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(news.title), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, " 掲載日時：" + _toDisplayString(_ctx.customDateFormat(news.start_showing)), 1),
              _createElementVNode("div", _hoisted_7, " 更新日時：" + _toDisplayString(_ctx.customDateFormat(news.updated_at)), 1),
              _createElementVNode("div", _hoisted_8, [
                _cache[0] || (_cache[0] = _createTextVNode(" 作成者：", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(news.author_name), 1),
                _createTextVNode(" (ID: " + _toDisplayString(news.employeeId) + ") ", 1)
              ])
            ])
          ], 8, _hoisted_3)), [
            [_directive_touch, void 0, "tap"]
          ])
        ]))
      }), 128))
    ]),
    (_ctx.showPageNavi)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_PageNavi, {
            "current-page": _ctx.currentPage,
            "max-page": _ctx.maxPage,
            "next-page-url": _ctx.nextPageUrl,
            "prev-page-url": _ctx.prevPageUrl,
            "base-url": _ctx.baseUrl,
            search: _ctx.searchKeyword
          }, null, 8, ["current-page", "max-page", "next-page-url", "prev-page-url", "base-url", "search"])
        ]))
      : _createCommentVNode("", true)
  ]))
}